import headshotImageSrc from "../static/headshot.webp";
import * as React from "react";
import {cn} from "../lib/utils";

export function Headshot (props: React.HTMLProps<HTMLImageElement>) {
    return <img alt={"Moritz Bruder"} src={headshotImageSrc} {...props} className={cn("backdrop-blur-lg object-cover", props.className)} />;
}